module.exports = __webpack_public_path__ + "img/green-leaves-extended.f470df38.png";